/* eslint-disable @typescript-eslint/default-param-last */
import { Action, Dispatch } from "redux";

interface Video {
  created_at?: string;
  id: number;
  sequence?: number;
  title: string;
  updated_at?: string;
  url: string;
  user_id?: number;
}

interface State {
  content: {
    description: string;
    heading: string;
  };
  videos: {
    data: Video[];
  };
}

interface ActionType extends Action {
  type: string | ((dispatch: Dispatch) => void);
  payload?: any;
}

const init: State = {
  content: {
    description: "",
    heading: "",
  },
  videos: {
    data: [],
  },
};

const videoTutorial = (state: State = init, action: ActionType): State => {
  if (action.type === "GET_VIDEO_TUTORIALS") {
    return { ...action.payload };
  }
  if (action.type === "CRUD_VIDEOS") {
    return {
      ...state,
      videos: {
        data: action.payload,
      },
    };
  }
  return state;
};

export default videoTutorial;
